export const usePrice = () => (price, locale, decimals = 2) => price.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
});
